export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["HEARTBEAT_ERROR"] = "HEARTBEAT_ERROR";
    ErrorCode["UNKNOWN"] = "UNKNOWN";
    // User errors
    ErrorCode["USER_EXISTS"] = "USER_EXISTS";
    ErrorCode["USER_NOT_VERIFIED"] = "USER_NOT_VERIFIED";
    ErrorCode["USER_CREATE_ERROR"] = "USER_CREATE_ERROR";
    ErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorCode["PASSWORD_CHANGE_ERROR"] = "PASSWORD_CHANGE_ERROR";
    ErrorCode["PASSWORD_NOT_VALID"] = "PASSWORD_NOT_VALID";
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    // Account errors
    ErrorCode["ACCOUNT_CREATE_ERROR"] = "ACCOUNT_CREATE_ERROR";
    ErrorCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ErrorCode["ACCOUNT_UPDATE_ERROR"] = "ACCOUNT_UPDATE_ERROR";
    ErrorCode["ACCOUNT_NOT_USER"] = "ACCOUNT_NOT_USER";
    ErrorCode["ACCOUNT_STORAGE_LIMIT_REACHED"] = "ACCOUNT_STORAGE_LIMIT_REACHED";
    ErrorCode["THEMES_NOT_FOUND"] = "THEMES_NOT_FOUND";
    // Organization errors
    ErrorCode["ORGANIZATION_EXISTS"] = "ORGANIZATION_EXISTS";
    ErrorCode["ORGANIZATION_CREATE_ERROR"] = "ORGANIZATION_CREATE_ERROR";
    ErrorCode["ORGANIZATION_NOT_FOUND"] = "ORGANIZATION_NOT_FOUND";
    ErrorCode["ORGANIZATION_UPDATE_ERROR"] = "ORGANIZATION_UPDATE_ERROR";
    ErrorCode["ORGANIZATION_DELETE_ERROR"] = "ORGANIZATION_DELETE_ERROR";
    ErrorCode["ORGANIZATION_LIST_ERROR"] = "ORGANIZATION_LIST_ERROR";
    ErrorCode["MEMBERSHIP_LIST_ERROR"] = "MEMBERSHIP_LIST_ERROR";
    ErrorCode["CANNOT_ORPHAN_ORGANIZATION"] = "CANNOT_ORPHAN_ORGANIZATION";
    // Membership errors
    ErrorCode["MEMBERSHIP_CREATE_ERROR"] = "MEMBERSHIP_CREATE_ERROR";
    ErrorCode["MEMBERSHIP_UPDATE_ERROR"] = "MEMBERSHIP_UPDATE_ERROR";
    ErrorCode["MEMBERSHIP_NOT_FOUND"] = "MEMBERSHIP_NOT_FOUND";
    ErrorCode["MEMBERSHIP_EXISTS"] = "MEMBERSHIP_EXISTS";
    ErrorCode["MEMBERSHIP_DELETE_ERROR"] = "MEMBERSHIP_DELETE_ERROR";
    ErrorCode["MEMBERSHIP_ORG_NOT_FOUND"] = "MEMBERSHIP_ORG_NOT_FOUND";
    ErrorCode["MEMBERSHIP_USER_NOT_FOUND"] = "MEMBERSHIP_USER_NOT_FOUND";
    // Group errors
    ErrorCode["ORGANIZATION_GROUP_CREATE_ERROR"] = "ORGANIZATION_GROUP_CREATE_ERROR";
    ErrorCode["ORGANIZATION_GROUP_NOT_FOUND"] = "ORGANIZATION_GROUP_NOT_FOUND";
    ErrorCode["ORGANIZATION_GROUP_UPDATE_ERROR"] = "ORGANIZATION_GROUP_UPDATE_ERROR";
    ErrorCode["ORGANIZATION_GROUP_DELETE_ERROR"] = "ORGANIZATION_GROUP_DELETE_ERROR";
    ErrorCode["ORGANIZATION_GROUP_LIST_ERROR"] = "ORGANIZATION_GROUP_LIST_ERROR";
    ErrorCode["ORGANIZATION_GROUP_MEMBERSHIP_CREATE_ERROR"] = "ORGANIZATION_GROUP_MEMBERSHIP_CREATE_ERROR";
    ErrorCode["ORGANIZATION_GROUP_MEMBERSHIP_DELETE_ERROR"] = "ORGANIZATION_GROUP_MEMBERSHIP_DELETE_ERROR";
    // Label errors
    ErrorCode["ORGANIZATION_LABEL_CREATE_ERROR"] = "ORGANIZATION_LABEL_CREATE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_NOT_FOUND"] = "ORGANIZATION_LABEL_NOT_FOUND";
    ErrorCode["ORGANIZATION_LABEL_UPDATE_ERROR"] = "ORGANIZATION_LABEL_UPDATE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_DELETE_ERROR"] = "ORGANIZATION_LABEL_DELETE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_LIST_ERROR"] = "ORGANIZATION_LABEL_LIST_ERROR";
    ErrorCode["ORGANIZATION_LABEL_READ_ERROR"] = "ORGANIZATION_LABEL_GROUP_NOT_FOUND";
    ErrorCode["ORGANIZATION_LABEL_GROUP_LIST_ERROR"] = "ORGANIZATION_LABEL_GROUP_LIST_ERROR";
    ErrorCode["ORGANIZATION_LABEL_GROUP_CREATE_ERROR"] = "ORGANIZATION_LABEL_GROUP_CREATE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_GROUP_UPDATE_ERROR"] = "ORGANIZATION_LABEL_GROUP_UPDATE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_GROUP_DELETE_ERROR"] = "ORGANIZATION_LABEL_GROUP_DELETE_ERROR";
    ErrorCode["ORGANIZATION_LABEL_ASSIGN_ERROR"] = "ORGANIZATION_LABEL_ASSIGN_ERROR";
    ErrorCode["ORGANIZATION_LABEL_ASSIGN_NOT_FOUND"] = "ORGANIZATION_LABEL_ASSIGN_NOT_FOUND";
    // Invitation errors
    ErrorCode["INVITATION_EXISTS"] = "INVITATION_EXISTS";
    ErrorCode["INVITATION_NOT_FOUND"] = "INVITATION_NOT_FOUND";
    ErrorCode["INVITATION_CREATE_ERROR"] = "INVITATION_CREATE_ERROR";
    ErrorCode["INVITATION_READ_ERROR"] = "INVITATION_READ_ERROR";
    ErrorCode["INVITATION_UPDATE_ERROR"] = "INVITATION_UPDATE_ERROR";
    ErrorCode["INVITATION_NOT_PENDING"] = "INVITATION_NOT_PENDING";
    ErrorCode["INVITATION_LIST_ERROR"] = "INVITATION_LIST_ERROR";
    ErrorCode["INVITATION_DELETE_ERROR"] = "INVITATION_DELETE_ERROR";
    // Project errors
    ErrorCode["PROJECT_CREATE_ERROR"] = "PROJECT_CREATE_ERROR";
    ErrorCode["PROJECT_NOT_FOUND"] = "PROJECT_NOT_FOUND";
    ErrorCode["PROJECT_UPDATE_ERROR"] = "PROJECT_UPDATE_ERROR";
    ErrorCode["PROJECT_TRASH_ERROR"] = "PROJECT_TRASH_ERROR";
    ErrorCode["PROJECT_READ_TRASH_ERROR"] = "PROJECT_READ_TRASH_ERROR";
    ErrorCode["PROJECT_EMPTY_TRASH_ERROR"] = "PROJECT_EMPTY_TRASH_ERROR";
    ErrorCode["PROJECT_UNTRASH_ERROR"] = "PROJECT_UNTRASH_ERROR";
    ErrorCode["PROJECT_ARCHIVE_ERROR"] = "PROJECT_ARCHIVE_ERROR";
    ErrorCode["PROJECT_UNARCHIVE_ERROR"] = "PROJECT_UNARCHIVE_ERROR";
    ErrorCode["PROJECT_LIST_ERROR"] = "PROJECT_LIST_ERROR";
    ErrorCode["PROJECT_CLOSE_ERROR"] = "PROJECT_CLOSE_ERROR";
    ErrorCode["PROJECT_REOPEN_ERROR"] = "PROJECT_REOPEN_ERROR";
    ErrorCode["PROJECT_STORAGE_LIMIT_REACHED"] = "PROJECT_STORAGE_LIMIT_REACHED";
    ErrorCode["PROJECT_DELETE_ERROR"] = "PROJECT_DELETE_ERROR";
    ErrorCode["PROJECT_WATCHERS_ERROR"] = "PROJECT_WATCHERS_ERROR";
    // Project template errors
    ErrorCode["PROJECT_TEMPLATE_CREATE_ERROR"] = "PROJECT_TEMPLATE_CREATE_ERROR";
    ErrorCode["PROJECT_TEMPLATE_UPDATE_ERROR"] = "PROJECT_TEMPLATE_UPDATE_ERROR";
    ErrorCode["PROJECT_TEMPLATE_READ_ERROR"] = "PROJECT_TEMPLATE_READ_ERROR";
    ErrorCode["PROJECT_TEMPLATE_NOT_FOUND"] = "PROJECT_TEMPLATE_NOT_FOUND";
    ErrorCode["PROJECT_TEMPLATE_ROLE_READ_ERROR"] = "PROJECT_TEMPLATE_ROLE_READ_ERROR";
    ErrorCode["PROJECT_TEMPLATE_ROLE_CREATE_ERROR"] = "PROJECT_TEMPLATE_ROLE_CREATE_ERROR";
    ErrorCode["PROJECT_TEMPLATE_ROLE_TASKS_ATTACH_ERROR"] = "PROJECT_TEMPLATE_ROLE_TASKS_ATTACH_ERROR";
    ErrorCode["PROJECT_TEMPLATE_ROLE_DELETE_ERROR"] = "PROJECT_TEMPLATE_ROLE_DELETE_ERROR";
    ErrorCode["PROJECT_TEMPLATE_DELETE_ERROR"] = "PROJECT_TEMPLATE_DELETE_ERROR";
    ErrorCode["PROJECT_TEMPLATE_STORAGE_LIMIT_REACHED"] = "PROJECT_TEMPLATE_STORAGE_LIMIT_REACHED";
    // Task errors
    ErrorCode["TASK_READ_ERROR"] = "TASK_READ_ERROR";
    ErrorCode["TASK_CREATE_FAILED"] = "TASK_CREATE_FAILED";
    ErrorCode["TASK_UPDATE_FAILED"] = "TASK_UPDATE_FAILED";
    ErrorCode["TASK_SEND_ERROR"] = "TASK_SEND_ERROR";
    ErrorCode["TASK_SEND_LIST_ERROR"] = "TASK_SEND_LIST_ERROR";
    ErrorCode["TASK_DUPLICATE_FAILED"] = "TASK_DUPLICATE_FAILED";
    ErrorCode["TASK_ACCEPT_FAILED"] = "TASK_ACCEPT_FAILED";
    ErrorCode["TASK_SEND_BACK_ERROR"] = "TASK_SEND_BACK_ERROR";
    ErrorCode["TASK_CANCEL_ERROR"] = "TASK_CANCEL_ERROR";
    ErrorCode["TASK_CLOSE_ERROR"] = "TASK_CLOSE_ERROR";
    ErrorCode["TASK_DELETE_ERROR"] = "TASK_DELETE_ERROR";
    ErrorCode["TASK_REQUEST_NOT_FOUND"] = "TASK_REQUEST_NOT_FOUND";
    ErrorCode["TASK_RESEND_RECIPIENT_NOTIFICATION_ERROR"] = "TASK_RESEND_RECIPIENT_NOTIFICATION_ERROR";
    ErrorCode["TASK_RECIPIENT_CONFIG_NOT_FOUND"] = "TASK_RECIPIENT_CONFIG_NOT_FOUND";
    ErrorCode["TASK_RECIPIENT_UPDATE_ERROR"] = "TASK_RECIPIENT_UPDATE_ERROR";
    // Recipient Reminders
    ErrorCode["CADENCE_CREATE_ERROR"] = "CADENCE_CREATE_ERROR";
    ErrorCode["CADENCE_NOT_FOUND"] = "CADENCE_NOT_FOUND";
    ErrorCode["CADENCE_UPDATE_ERROR"] = "CADENCE_UPDATE_ERROR";
    ErrorCode["CADENCE_DELETE_ERROR"] = "CADENCE_DELETE_ERROR";
    ErrorCode["REMINDER_SETTINGS_CREATE_ERROR"] = "REMINDER_SETTINGS_CREATE_ERROR";
    ErrorCode["REMINDER_SETTINGS_NOT_FOUND"] = "REMINDER_SETTINGS_NOT_FOUND";
    ErrorCode["REMINDER_SETTINGS_DELETE_ERROR"] = "REMINDER_SETTINGS_DELETE_ERROR";
    ErrorCode["REMINDER_SETTINGS_UPDATE_ERROR"] = "REMINDER_SETTINGS_UPDATE_ERROR";
    ErrorCode["REMINDER_SEND_ERROR"] = "REMINDER_SEND_ERROR";
    // Task Section errors
    ErrorCode["TASK_SECTION_READ_ERROR"] = "TASK_SECTION_READ_ERROR";
    ErrorCode["TASK_SECTION_CREATE_ERROR"] = "TASK_SECTION_CREATE_ERROR";
    ErrorCode["TASK_SECTION_UPDATE_ERROR"] = "TASK_SECTION_UPDATE_ERROR";
    ErrorCode["TASK_SECTION_BLOCK_CREATE_ERROR"] = "TASK_SECTION_BLOCK_CREATE_ERROR";
    ErrorCode["TASK_SECTION_BLOCK_UPDATE_ERROR"] = "TASK_SECTION_BLOCK_UPDATE_ERROR";
    ErrorCode["TASK_SECTION_INVALID_TYPE"] = "TASK_SECTION_INVALID_TYPE";
    // Task template errors
    ErrorCode["TASK_CREATE_FROM_TASK_TEMPLATE_ERROR"] = "TASK_CREATE_FROM_TASK_TEMPLATE_ERROR";
    ErrorCode["TASK_TEMPLATE_UPDATE_FAILED"] = "TASK_TEMPLATE_UPDATE_FAILED";
    ErrorCode["TASK_TEMPLATE_CREATE_ERROR"] = "TASK_TEMPLATE_CREATE_ERROR";
    ErrorCode["TASK_TEMPLATE_NOT_FOUND"] = "TASK_TEMPLATE_NOT_FOUND";
    ErrorCode["TASK_TEMPLATE_UPDATE_ERROR"] = "TASK_TEMPLATE_UPDATE_ERROR";
    ErrorCode["TASK_TEMPLATE_DELETE_ERROR"] = "TASK_TEMPLATE_DELETE_ERROR";
    ErrorCode["TASK_TEMPLATE_LIST_ERROR"] = "TASK_TEMPLATE_LIST_ERROR";
    ErrorCode["TASK_TEMPLATE_READ_ERROR"] = "TASK_TEMPLATE_READ_ERROR";
    ErrorCode["TASK_TEMPLATE_CREATE_FROM_TASK_ERROR"] = "TASK_TEMPLATE_CREATE_FROM_TASK_ERROR";
    // File errors
    ErrorCode["FILE_READ_ERROR"] = "FILE_READ_ERROR";
    ErrorCode["FILE_UPLOAD_ERROR"] = "FILE_UPLOAD_ERROR";
    ErrorCode["FILE_CREATE_ERROR"] = "FILE_CREATE_ERROR";
    ErrorCode["FILE_UPDATE_ERROR"] = "FILE_UPDATE_ERROR";
    ErrorCode["FILE_ASSOCIATE_ERROR"] = "FILE_ASSOCIATE_ERROR";
    ErrorCode["FILE_NOT_FOUND"] = "FILE_NOT_FOUND";
    ErrorCode["FILE_DELETE_ERROR"] = "FILE_DELETE_ERROR";
    ErrorCode["FILE_COPY_ERROR"] = "FILE_COPY_ERROR";
    ErrorCode["FILE_DOWNLOAD_ERROR"] = "FILE_DOWNLOAD_ERROR";
    ErrorCode["FILE_UPLOAD_SESSION_CREATION_ERROR"] = "FILE_UPLOAD_SESSION_CREATION_ERROR";
    ErrorCode["FILE_PART_UPLOAD_ERROR"] = "FILE_PART_UPLOAD_ERROR";
    ErrorCode["FILE_UPLOAD_COMPLETION_ERROR"] = "FILE_UPLOAD_COMPLETION_ERROR";
    // File Relation errors
    ErrorCode["FILE_RELATION_NOT_FOUND"] = "FILE_RELATION_NOT_FOUND";
    ErrorCode["FILE_RELATION_DUPLICATE_ERROR"] = "FILE_RELATION_DUPLICATE_ERROR";
    ErrorCode["FILE_RELATION_DELETE_ERROR"] = "FILE_RELATION_DELETE_ERROR";
    // Email errors
    ErrorCode["EMAIL_SEND_ERROR"] = "EMAIL_SEND_ERROR";
    ErrorCode["VERIFICATION_ERROR"] = "VERIFICATION_ERROR";
    // Token errors
    ErrorCode["TOKEN_ERROR"] = "TOKEN_ERROR";
    // Recipient responding
    ErrorCode["RECIPIENT_RESPONSE_GET_ERROR"] = "RECIPIENT_RESPONSE_GET_ERROR";
    ErrorCode["RECIPIENT_RESPONSE_VIEWED_TASK_ERROR"] = "RECIPIENT_VIEWED_TASK_ERROR";
    ErrorCode["RECIPIENT_RESPONSE_SUBMIT_ERROR"] = "RECIPIENT_RESPONSE_SUBMIT_ERROR";
    ErrorCode["RECIPIENT_RESPONSE_FILE_UPLOAD_ERROR"] = "RECIPIENT_RESPONSE_FILE_UPLOAD_ERROR";
    ErrorCode["RECIPIENT_RESPONSE_FILE_DELETE_ERROR"] = "RECIPIENT_RESPONSE_FILE_DELETE_ERROR";
    ErrorCode["RECIPIENT_RESPONSE_PROJECT_NOT_FOUND"] = "RECIPIENT_RESPONSE_PROJECT_NOT_FOUND";
    ErrorCode["RECIPIENT_RESPONSE_DECLINE_ERROR"] = "RECIPIENT_RESPONSE_DECLINE_ERROR";
    ErrorCode["RECIPIENT_NOT_FOUND"] = "RECIPIENT_NOT_FOUND";
    ErrorCode["RECIPIENT_TASK_VIEW_ERROR"] = "RECIPIENT_TASK_VIEW_ERROR";
    ErrorCode["RECIPIENT_PROJECT_VIEW_ERROR"] = "RECIPIENT_PROJECT_VIEW_ERROR";
    ErrorCode["RECIPIENT_NOTIFICATION_CONTROL_ERROR"] = "RECIPIENT_NOTIFICATION_CONTROL_ERROR";
    // Organization Recipients
    ErrorCode["ORGANIZATION_RECIPIENT_FIND_ERROR"] = "ORGANIZATION_RECIPIENT_FIND_ERROR";
    ErrorCode["ORGANIZATION_RECIPIENT_CREATE_ERROR"] = "ORGANIZATION_RECIPIENT_CREATE_ERROR";
    ErrorCode["ORGANIZATION_RECIPIENT_UPDATE_ERROR"] = "ORGANIZATION_RECIPIENT_UPDATE_ERROR";
    ErrorCode["ORGANIZATION_RECIPIENT_DELETE_ERROR"] = "ORGANIZATION_RECIPIENT_DELETE_ERROR";
    ErrorCode["ORGANIZATION_RECIPIENT_GEN_REMINDER_ERROR"] = "ORGANIZATION_RECIPIENT_GEN_REMINDER_ERROR";
    ErrorCode["RECIPIENT_PROJECT_SETTINGS_CREATE_ERROR"] = "RECIPIENT_PROJECT_SETTINGS_CREATE_ERROR";
    ErrorCode["RECIPIENT_PROJECT_SETTINGS_UPDATE_ERROR"] = "RECIPIENT_PROJECT_SETTINGS_UPDATE_ERROR";
    ErrorCode["RECIPIENT_PROJECT_SETTINGS_FIND_ERROR"] = "RECIPIENT_PROJECT_SETTINGS_FIND_ERROR";
    // Recipients global
    ErrorCode["RECIPIENT_FIND_ERROR"] = "RECIPIENT_FIND_ERROR";
    ErrorCode["RECIPIENT_CREATE_ERROR"] = "RECIPIENT_CREATE_ERROR";
    ErrorCode["RECIPIENT_UPDATE_ERROR"] = "RECIPIENT_UPDATE_ERROR";
    ErrorCode["RECIPIENT_DELETE_ERROR"] = "RECIPIENT_DELETE_ERROR";
    // Contacts
    ErrorCode["CONTACT_LIST_ERROR"] = "CONTACT_LIST_ERROR";
    ErrorCode["CONTACT_CREATE_ERROR"] = "CONTACT_CREATE_ERROR";
    ErrorCode["CONTACT_READ_ERROR"] = "CONTACT_READ_ERROR";
    ErrorCode["CONTACT_UPDATE_ERROR"] = "CONTACT_UPDATE_ERROR";
    ErrorCode["CONTACT_DELETE_ERROR"] = "CONTACT_DELETE_ERROR";
    ErrorCode["CONTACT_DELETE_BULK_ERROR"] = "CONTACT_DELETE_BULK_ERROR";
    // Activity
    ErrorCode["ACTIVITY_LIST_ERROR"] = "ACTIVITY_LIST_ERROR";
    // Server errors
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    ErrorCode["INVALID_DATA"] = "INVALID_DATA";
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Emails
    ErrorCode["EMAIL_TEMPLATE_ERROR"] = "EMAIL_TEMPLATE_ERROR";
    ErrorCode["EMAIL_TEMPLATE_NOT_FOUND"] = "EMAIL_TEMPLATE_NOT_FOUND";
    ErrorCode["LOCK_ACQUIRE_ERROR"] = "LOCK_ACQUIRE_ERROR";
    ErrorCode["CACHE_DELETE_ERROR"] = "CACHE_DELETE_ERROR";
    // Notifications
    ErrorCode["NOTIFICATION_READ_ERROR"] = "NOTIFICATION_READ_ERROR";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=errors.js.map